"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMovetexSyncResponse = exports.MovetexSyncResponseStatusEnum = void 0;
const imovetex_external_interface_result_1 = require("./imovetex-external-interface-result");
/**
    * @export
    * @enum {string}
    */
var MovetexSyncResponseStatusEnum;
(function (MovetexSyncResponseStatusEnum) {
    MovetexSyncResponseStatusEnum["Created"] = "created";
    MovetexSyncResponseStatusEnum["Updated"] = "updated";
    MovetexSyncResponseStatusEnum["Deleted"] = "deleted";
    MovetexSyncResponseStatusEnum["Failed"] = "failed";
    MovetexSyncResponseStatusEnum["Skipped"] = "skipped";
})(MovetexSyncResponseStatusEnum || (exports.MovetexSyncResponseStatusEnum = MovetexSyncResponseStatusEnum = {}));
function parseMovetexSyncResponse(data) {
    if (data.result !== null && typeof data.result === 'object')
        data.result = (0, imovetex_external_interface_result_1.parseIMovetexExternalInterfaceResult)(data.result);
    return data;
}
exports.parseMovetexSyncResponse = parseMovetexSyncResponse;
